import { GridContainer, GridItem } from '@design-system/grid';
import { HeadingBlock } from '@design-system/heading-block';
import { PageBlock } from '@design-system/page-block';
import {
  PromoFormBlock,
  PromoFormProps,
} from '@design-system/promo-form-block';
import React, { FC, useState } from 'react';

import { PromoFormCSProps } from './models';
import ThankYou from './ThankYou';

const PromoForm: FC<PromoFormCSProps> = ({
  pageBlockUI,
  componentId,
  heading,
  form,
  thankYou,
  uid,
}) => {
  const [showThankYou, setShowThankYou] = useState(false);
  const [resetForm, setResetForm] = useState(() => () => {});

  const onFormSent: PromoFormProps['onSuccessCallback'] = (_, reset) => {
    setShowThankYou(true);
    setResetForm(() => reset);
  };

  const thankYouCloseHandler = () => {
    setShowThankYou(false);
    if (resetForm) resetForm();
  };

  return (
    <PageBlock
      {...pageBlockUI}
      id={componentId}
      className="promo-form"
      componentUid={uid}
    >
      <GridContainer className="promo-form__grid">
        <GridItem md={4}>
          {heading ? <HeadingBlock {...heading} /> : null}
          <PromoFormBlock
            {...form}
            onSuccessCallback={
              !form.thankYouPageRedirect ? onFormSent : undefined
            }
            disabled={showThankYou}
          />
        </GridItem>
      </GridContainer>
      {showThankYou ? (
        <ThankYou {...thankYou} closeHandler={thankYouCloseHandler} />
      ) : null}
    </PageBlock>
  );
};

export default PromoForm;
